/* ===== CONFIGURACIÓN LC INGENIEROS =====
   WHATSAPP: número con indicativo de Colombia, sin "+" ni espacios.
   CORREO: a donde llegan PQR, hojas de vida y cotizaciones (vía FormSubmit).
   La primera vez que alguien envíe un formulario desde el dominio, FormSubmit
   manda un correo de activación a CORREO: hay que abrirlo y confirmar una sola vez. */
const CONFIG = {
  WHATSAPP: "573138052079",
  CORREO: "saslcingenieros@gmail.com",
  FORM_ENDPOINT: "https://formsubmit.co/ajax/saslcingenieros@gmail.com"
};

document.documentElement.classList.add('js');

/* cada página abre desde arriba y con transición suave */
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
const navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
if (navEntry.type !== 'back_forward' && !location.hash) {
  document.documentElement.style.scrollBehavior = 'auto'; scrollTo(0, 0);
  requestAnimationFrame(() => { scrollTo(0, 0); document.documentElement.style.scrollBehavior = ''; });
}
addEventListener('pageshow', e => { document.documentElement.classList.remove('leaving'); if (e.persisted) document.body.style.opacity = ''; });
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.addEventListener('click', e => {
  const a = e.target.closest('a[href]');
  if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  const url = new URL(a.href, location.href);
  if (url.origin !== location.origin || url.pathname === location.pathname || !/^https?:$/.test(url.protocol)) return;
  e.preventDefault();
  if (reduce) { location.href = url.href; return; }
  document.documentElement.classList.add('leaving');
  setTimeout(() => { location.href = url.href; }, 260);
});
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const store = { get(k){ try { return sessionStorage.getItem(k); } catch(_) { return null; } },
                set(k,v){ try { sessionStorage.setItem(k,v); } catch(_) {} },
                del(k){ try { sessionStorage.removeItem(k); } catch(_) {} } };

/* nav */
const nav = $('#nav'), burger = $('#burger');
const onScroll = () => nav.classList.toggle('solid', scrollY > 40);
onScroll(); addEventListener('scroll', onScroll, { passive: true });
burger.addEventListener('click', () => {
  const o = nav.classList.toggle('open');
  burger.setAttribute('aria-expanded', o);
  document.body.style.overflow = o ? 'hidden' : '';
});

/* aparición suave solo para lo que está fuera de pantalla */
if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.remove('pre'); io.unobserve(e.target); }
  }), { threshold: .12 });
  $$('.reveal').forEach(el => { if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('pre'); io.observe(el); } });
}

/* WhatsApp */
const waLink = msg => 'https://wa.me/' + CONFIG.WHATSAPP + '?text=' + encodeURIComponent(msg);
$$('[data-wa]').forEach(a => { a.href = waLink(a.dataset.wa); a.target = '_blank'; a.rel = 'noopener'; });

/* botones "Cotizar X" → preseleccionan el servicio en Contacto */
$$('[data-servicio]').forEach(a => a.addEventListener('click', () => store.set('lc-servicio', a.dataset.servicio)));
const sel = $('#c-servicio');
if (sel) {
  const v = new URLSearchParams(location.search).get('servicio') || store.get('lc-servicio');
  if (v) { [...sel.options].forEach(o => { if (o.text === v || o.text.startsWith(v)) sel.value = o.value || o.text; }); store.del('lc-servicio'); }
}

/* filtros de proyectos */
const fbtns = $$('.filters button');
fbtns.forEach(b => b.addEventListener('click', () => {
  fbtns.forEach(x => x.setAttribute('aria-pressed', x === b));
  $$('#gallery .proj').forEach(p => p.hidden = !(b.dataset.f === 'todos' || p.dataset.cat === b.dataset.f));
}));

/* visor de fotos */
const lb = $('#lb'), lbImg = $('#lb-img');
let set = [], idx = 0, lastFocus = null;
function show(){ lbImg.src = (window.LC_IMG || 'img/') + set[idx] + '.jpg'; $('#lb-c').textContent = (idx + 1) + ' / ' + set.length;
  $('#lb-p').hidden = $('#lb-n').hidden = set.length < 2; }
$$('.proj').forEach(p => p.addEventListener('click', () => {
  set = p.dataset.imgs.split(','); idx = 0; lastFocus = p;
  $('#lb-t').textContent = $('.t', p).textContent; lbImg.alt = $('img', p).alt;
  show(); lb.hidden = false; document.body.style.overflow = 'hidden'; $('#lb-x').focus();
}));
function closeLb(){ lb.hidden = true; document.body.style.overflow = ''; lastFocus && lastFocus.focus(); }
if (lb) {
  $('#lb-x').onclick = closeLb;
  $('#lb-p').onclick = () => { idx = (idx - 1 + set.length) % set.length; show(); };
  $('#lb-n').onclick = () => { idx = (idx + 1) % set.length; show(); };
  lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('lb-stage')) closeLb(); });
  addEventListener('keydown', e => {
    if (lb.hidden) return;
    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowLeft') $('#lb-p').click();
    if (e.key === 'ArrowRight') $('#lb-n').click();
  });
}

/* formularios → correo de la empresa */
function radicado(kind){
  const p = { PQR: 'PQR', 'Hoja de vida': 'HV', 'Cotización': 'COT' }[kind] || 'SOL';
  const d = new Date(), pad = n => String(n).padStart(2, '0');
  return 'LC-' + p + '-' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' + (Math.floor(Math.random() * 9000) + 1000);
}
$$('form.form').forEach(f => f.addEventListener('submit', async e => {
  e.preventDefault();
  let ok = true;
  $$('.field', f).forEach(fl => {
    const inp = $('input[required],select[required],textarea[required]', fl); if (!inp) return;
    const err = $('.err', fl); let msg = '';
    if (!inp.value.trim()) msg = 'Este campo es obligatorio.';
    else if (inp.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value)) msg = 'Escribe un correo válido, por ejemplo nombre@correo.com.';
    else if (inp.type === 'tel' && inp.value.replace(/\D/g, '').length < 7) msg = 'Escribe un número de al menos 7 dígitos.';
    fl.classList.toggle('bad', !!msg); if (err) err.textContent = msg; if (msg) ok = false;
  });
  const hd = $('input[name="habeas"]', f);
  if (hd) { hd.closest('.check').style.color = hd.checked ? '' : 'var(--danger)'; if (!hd.checked) ok = false; }
  if (!ok) { const b = $('.bad input,.bad select,.bad textarea', f); b && b.focus(); return; }

  const kind = f.dataset.kind, rad = radicado(kind), data = new FormData(f);
  const btn = $('button[type=submit]', f), btnTxt = btn.textContent;
  btn.disabled = true; btn.textContent = 'Enviando…';

  const lines = ['*' + kind + ' · LC Ingenieros*', 'Radicado: ' + rad];
  for (const [k, v] of data.entries()) if (k !== 'habeas' && v && !(v instanceof File)) lines.push(k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' ') + ': ' + v);
  const text = lines.join('\n');

  data.delete('habeas');
  data.append('Radicado', rad); data.append('Formulario', kind);
  data.append('_subject', kind + ' ' + rad + ' · Sitio web LC Ingenieros');
  data.append('_template', 'table'); data.append('_captcha', 'false');
  const correo = data.get('correo'); if (correo) data.append('_replyto', correo);

  let sent = false;
  try {
    const r = await fetch(CONFIG.FORM_ENDPOINT, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    sent = r.ok;
  } catch (_) {}
  btn.disabled = false; btn.textContent = btnTxt;

  const box = document.createElement('div'); box.className = 'done'; box.setAttribute('role', 'status');
  box.innerHTML = sent
    ? '<b>Solicitud enviada</b><span class="rad"></span><p class="muted">Guarda este número para hacer seguimiento. Te responderemos pronto.</p>'
    : '<b>No pudimos enviarla desde aquí</b><span class="rad"></span><p class="muted">Envíanos el resumen por WhatsApp o al correo ' + CONFIG.CORREO + ' y quedará radicada.</p><pre></pre><div class="row"><a class="btn" target="_blank" rel="noopener">Enviar por WhatsApp</a><button type="button" class="btn ghost copy">Copiar resumen</button></div>';
  $('.rad', box).textContent = 'Radicado ' + rad;
  const pre = $('pre', box); if (pre) pre.textContent = text;
  const wa = $('a.btn', box); if (wa) wa.href = waLink(text);
  const cp = $('.copy', box);
  if (cp) cp.onclick = () => navigator.clipboard.writeText(text).then(() => cp.textContent = 'Copiado', () => {
    const r = document.createRange(); r.selectNodeContents(pre); const s = getSelection(); s.removeAllRanges(); s.addRange(r); cp.textContent = 'Texto seleccionado';
  });
  $$('.done', f).forEach(d => d.remove());
  if (sent) f.reset();
  f.appendChild(box); box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
}));
